import { FieldSet, Label, LabeledControl, Legend, Radio, Text } from '@zillow/constellation-10';

import { RentalManagerFreemiumAnalyticsFilterType } from '@zg-rentals/ts-rental-manager-api-beta-client';
import { useRentalManagerUserFreemiumAnalyticsWebApiHandler_overview } from '@zg-rentals/ts-rental-manager-api-beta-client-react-query';

import PropertyConstants from '../../../../../../constants/PropertyConstants';

import { usePremiumAnalyticsContext } from '../../../../PremiumAnalyticsContext';

import type { Filters as FiltersType } from '../../../../types';

type FiltersProps = {
  listingAlias: string;
};

const Filters = ({ listingAlias }: FiltersProps) => {
  const { filters, setFilters } = usePremiumAnalyticsContext();
  const { beds, filterType, propertyType } = filters;

  const { data: premiumOverview } = useRentalManagerUserFreemiumAnalyticsWebApiHandler_overview(
    {
      listingAlias,
      filterType: RentalManagerFreemiumAnalyticsFilterType.CITY_STATE,
      beds,
      propertyType,
    },
    {
      enabled: !!listingAlias,
      placeholderData: (previousData) => previousData,
    },
  );

  const myPropertyDetailsFilters: FiltersType = {
    filterType: RentalManagerFreemiumAnalyticsFilterType.ZIP,
    propertyType: PropertyConstants.PROPERTY_CODE_TO_ENUM[premiumOverview?.propertyType?.code ?? 0],
    beds: premiumOverview?.beds !== undefined ? String(premiumOverview.beds) : undefined,
  };

  const allPropertiesFilters: FiltersType = {
    filterType: RentalManagerFreemiumAnalyticsFilterType.CITY_STATE,
    propertyType: undefined,
    beds: undefined,
  };

  if (!premiumOverview) {
    return null;
  }

  const handleFilterChange = (newFilters: FiltersType) => {
    setFilters(newFilters);
  };

  const isMyPropertyDetailsChecked =
    beds === String(premiumOverview.beds) && filterType === RentalManagerFreemiumAnalyticsFilterType.ZIP;
  const isAllPropertiesChecked =
    beds === undefined && filterType === RentalManagerFreemiumAnalyticsFilterType.CITY_STATE;

  return (
    <FieldSet
      legend={<Legend>Data source</Legend>}
      css={{
        display: 'flex',
        alignItems: { base: 'flex-start', xl: 'center' },
        flexDirection: { base: 'column', xl: 'row' },
        justifyContent: 'space-between',
        marginBottom: '600',
        paddingLeft: { base: '200', lg: 0 },
      }}
    >
      <LabeledControl
        css={{ marginRight: '400' }}
        key="myPropertyDetails"
        label={
          <Label>
            <Text textStyle="body-sm" asChild>
              <span>
                {typeof premiumOverview?.beds !== 'undefined' ? `${premiumOverview?.beds} bedroom` : 'All'}{' '}
                {premiumOverview?.propertyType?.display.toLowerCase()}s in {premiumOverview?.zip}
              </span>
            </Text>
          </Label>
        }
        control={
          <Radio
            name="compFilter"
            onChange={() => handleFilterChange(myPropertyDetailsFilters)}
            checked={isMyPropertyDetailsChecked}
          />
        }
      />
      <LabeledControl
        key="all"
        label={
          <Label>
            <Text textStyle="body-sm" asChild>
              <span>All {premiumOverview?.city} rentals</span>
            </Text>
          </Label>
        }
        control={
          <Radio
            name="compFilter"
            onChange={() => handleFilterChange(allPropertiesFilters)}
            checked={isAllPropertiesChecked}
          />
        }
      />
    </FieldSet>
  );
};

export default Filters;
